export const FISCAL_CATEGORY_OPTIONS = [
  { value: 'auto_entrepreneur', label: 'Auto-entrepreneur' },
  { value: 'regime_reel', label: 'Régime réel' },
  { value: 'regime_forfaitaire', label: 'Régime forfaitaire' },
]

export const FISCAL_CATEGORY_LABELS = Object.fromEntries(
  FISCAL_CATEGORY_OPTIONS.map((option) => [option.value, option.label])
)

export const normalizeFiscalCategory = (value) => {
  if (value === 'regime_reel' || value === 'regime_forfaitaire') return value
  return 'auto_entrepreneur'
}

export const isAutoEntrepreneur = (coach) =>
  normalizeFiscalCategory(coach?.fiscalCategory) === 'auto_entrepreneur'

export const formatFiscalCategoryLabel = (value) =>
  FISCAL_CATEGORY_LABELS[normalizeFiscalCategory(value)] || 'Auto-entrepreneur'
